import React from 'react';
import clsx from 'clsx';
import { Input } from '@components/basics/forms/inputs/Input';
import { humanReadableChainName } from '@utils/helpers';

export const TokenInput = ({
  chainId,
  tokenSymbol,
  icon,
  amount,
  setAmount,
  placeholder,
  balance,
  className,
  ...props
}: {
  chainId: number;
  tokenSymbol: string;
  icon: JSX.Element;
  amount: string | null;
  balance?: string;
  placeholder?: string;
  setAmount: (amount: string | null) => void;
} & React.InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <div className="grid gap-1">
      <div className="flex rounded-[6px] border border-base200">
        <div className="flex items-center gap-2 py-3 pl-2 pr-4">
          {icon}
          <div className="grid gap-[2px]">
            <div className="text-title-xs font-medium text-base800">{tokenSymbol}</div>
            <div className="text-base-s leading-[14px]">{humanReadableChainName(chainId)}</div>
          </div>
        </div>
        <Input
          type="number"
          value={amount ?? ''}
          placeholder={placeholder ?? 'Amount'}
          autoComplete="off"
          onChange={e => {
            setAmount(e.target.value);
          }}
          className={clsx('rounded-l-none', className)}
          {...props}
        />
      </div>
      {balance ? (
        <div className="text-base-s text-base400">{balance}</div>
      ) : (
        <div className="h-4 w-28 animate-pulse rounded-lg bg-base400" />
      )}
    </div>
  );
};
